// extracted by mini-css-extract-plugin
var _1 = "ClientNotesCreate_category__9Lolt";
var _2 = "ClientNotesCreate_container__XAstF";
var _3 = "ClientNotesCreate_show__Rh7Jg";
export { _1 as "category", _2 as "container", _3 as "show" }
